<div class="flex flex-col space-y-4">
  <!-- All Austria Checkbox -->
  <div class="flex items-center">
    <mat-checkbox
      [formControl]="$any(locationForm.get('allAustria'))"
      class="text-gray-700"
      data-testid="all-austria-checkbox"
    >
      Ganz Österreich
    </mat-checkbox>
  </div>

  <!-- State Selection (disabled when allAustria is checked) -->
  @if (!locationForm.get("allAustria")?.value) {
    <div>
      <mat-form-field class="w-full" data-testid="state-select-field">
        <mat-label>Bundesländer auswählen</mat-label>
        <mat-select
          [formControl]="$any(locationForm.get('selectedStates'))"
          multiple
          data-testid="state-select"
        >
          @for (state of states; track state) {
            <mat-option
              [value]="state.id"
              [attr.data-testid]="'state-option-' + state.id"
            >
              {{ state.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!-- Selected States -->
      @if (locationForm.get("selectedStates")?.value?.length) {
        <div class="mt-2">
          <div class="text-sm font-medium text-gray-700 mb-2">
            Ausgewählte Bundesländer:
          </div>
          <div class="flex flex-wrap gap-2">
            @for (
              stateId of locationForm.get("selectedStates")?.value;
              track stateId
            ) {
              <mat-chip [removable]="true" (removed)="removeState(stateId)">
                {{ getStateName(stateId) }}
                <button matChipRemove>
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
            }
          </div>
        </div>
      }
    </div>
  }

  <!-- District Selection (only shown when states are selected) -->
  @if (
    !locationForm.get("allAustria")?.value &&
    locationForm.get("selectedStates")?.value?.length
  ) {
    <div>
      <mat-form-field class="w-full" data-testid="district-select-field">
        <mat-label
          >Bezirke auswählen
          <span class="text-gray-500">(optional)</span></mat-label
        >
        <mat-select
          [formControl]="$any(locationForm.get('selectedDistricts'))"
          multiple
          data-testid="district-select"
        >
          @for (district of districts; track district) {
            <mat-option
              [value]="district.id"
              [attr.data-testid]="'district-option-' + district.id"
            >
              {{ district.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!-- Selected Districts -->
      @if (locationForm.get("selectedDistricts")?.value?.length) {
        <div class="mt-2">
          <div class="text-sm font-medium text-gray-700 mb-2">
            Ausgewählte Bezirke:
          </div>
          <div class="flex flex-wrap gap-2">
            @for (
              districtId of locationForm.get("selectedDistricts")?.value;
              track districtId
            ) {
              <mat-chip
                [removable]="true"
                (removed)="removeDistrict(districtId)"
              >
                {{ getDistrictName(districtId) }}
                <button matChipRemove>
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
            }
          </div>
        </div>
      }
    </div>
  }

  <!-- Location Selection -->
  @if (
    !locationForm.get("allAustria")?.value &&
    locationForm.get("selectedStates")?.value?.length &&
    locationForm.get("selectedDistricts")?.value?.length
  ) {
    <div class="space-y-2">
      <mat-form-field class="w-full" data-testid="location-search-field">
        <mat-label>
          Orte auswählen
          <span class="text-gray-500">(optional)</span>
        </mat-label>
        <input
          matInput
          [formControl]="$any(locationForm.get('locationSearch'))"
          placeholder="Nach PLZ oder Ortsname suchen"
          data-testid="location-search-input"
        />
        <button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="locationForm.get('locationSearch')?.setValue('')"
          data-testid="location-search-clear"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <!-- Location Options -->
      <div
        class="max-h-60 overflow-y-auto border rounded-md"
        data-testid="location-options"
      >
        @for (location of filteredLocations | async; track location) {
          <div
            class="hover:bg-gray-100 cursor-pointer flex items-center"
            (click)="onLocationSelected(location)"
            (keydown.enter)="onLocationSelected(location)"
            tabindex="0"
            role="button"
            [attr.aria-label]="'Select location ' + location.name"
            [attr.data-testid]="'location-option-' + location.id"
          >
            <mat-checkbox
              [checked]="isLocationSelected(location)"
              (click)="$event.stopPropagation(); onLocationSelected(location)"
              class="mr-2"
            ></mat-checkbox>
            {{ location.plz }} - {{ location.name }}
          </div>
        }
      </div>
      <!-- Selected Locations -->
      @if (locationForm.get("selectedLocations")?.value?.length) {
        <div class="mt-2">
          <div class="text-sm font-medium text-gray-700 mb-2">
            Ausgewählte Orte:
          </div>
          <div class="flex flex-wrap gap-2">
            @for (
              location of locationForm.get("selectedLocations")?.value;
              track location
            ) {
              <mat-chip [removable]="true" (removed)="removeLocation(location)">
                {{ location.name }} ({{ location.plz }})
                <button matChipRemove>
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
